import { routes as requestItemsRoutes } from "./request-items/routes";

export const routes = (prefix = `loan-items`) => [
    ...requestItemsRoutes(prefix),
];
